<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:new="createHandler"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import PersonPayrollDirectAssignment from "../../../components/payroll/personpayrolldirectassingment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PersonPayrollDirectAssignment,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuppersonpayrolldirectassignment.editpersonpayrolldirectassignment'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadPsnPayrollDirectAssignmentHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/psnpayrolldirectassignment/" + vm.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.formData.startdate = moment(vm.formData.startdate).format(
            "YYYY-MM-DD"
          );
          vm.formData.enddate = moment(vm.formData.enddate).format(
            "YYYY-MM-DD"
          );

          vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.userid = this.$store.getters.userId;
          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url:
            "/psnpayrolldirectassignment/" +
            vm.formData.id, payload: this.formData})
        .then((res) => {
          console.log(res);
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "personpayrolldirectassignmentlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/psnpayrolldirectassignment/" +
            vm.formData.id +
            "/" +
            vm.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "personpayrolldirectassignmentlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "personpayrolldirectassignmentnew" });
    },
  },

  async mounted() {
    await this.loadPsnPayrollDirectAssignmentHandler();
  },
};
</script>